import { DEMO_TOKEN_KEY, isDemoMode } from './demo/runtime.js';

const TOKEN_KEY = 'anforderungsai.authToken';
const MODE_KEYS = {
  real: TOKEN_KEY,
  demo: DEMO_TOKEN_KEY,
};

const tokenCache = {
  real: undefined,
  demo: undefined,
};

const getStorage = (mode) => {
  try {
    return mode === 'demo' ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
};

const readFromStorage = (mode) => {
  try {
    const storage = getStorage(mode);
    if (!storage) return null;
    return storage.getItem(MODE_KEYS[mode] ?? TOKEN_KEY);
  } catch (error) {
    console.warn('Failed to read auth token from storage', error);
    return null;
  }
};

const writeToStorage = (mode, token) => {
  try {
    const storage = getStorage(mode);
    if (!storage) return;
    const key = MODE_KEYS[mode] ?? TOKEN_KEY;
    if (token) {
      storage.setItem(key, token);
    } else {
      storage.removeItem(key);
    }
  } catch (error) {
    console.warn('Failed to persist auth token', error);
  }
};

export const getAuthToken = () => {
  const mode = isDemoMode() ? 'demo' : 'real';
  if (tokenCache[mode] !== undefined) {
    return tokenCache[mode];
  }
  const stored = readFromStorage(mode);
  tokenCache[mode] = stored ?? null;
  return tokenCache[mode];
};

export const setAuthToken = (token) => {
  const mode = isDemoMode() ? 'demo' : 'real';
  tokenCache[mode] = token ?? null;
  writeToStorage(mode, tokenCache[mode]);
};

export const clearAuthToken = () => {
  const mode = isDemoMode() ? 'demo' : 'real';
  tokenCache[mode] = null;
  writeToStorage(mode, null);
};
